import React, { useState, useRef } from 'react';
import { Button, Modal } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Modall = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // States for form fields
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [isSubmit, setIsSubmit] = useState(false)
  const fullLink = window.location.href

  // Create a ref for the form element
  const formRef = useRef(null);

  const showLoading = () => {
    setOpen(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const sbtHnd2 = async (e) => {
    e.preventDefault();
    setIsSubmit(true)

    // Form data to send
    const formData = {
      name: name,
      mobile: mobile,
      email: email,
      city: city,
      link: fullLink
    };
    console.log(formData, " fd")

    try {
      //const res = await axios.post("http://localhost:8000/sendData", { formData })

      // if (res.status === 200) {
      //   setIsSubmit(false)
      //   alert('Form submitted successfully!');
      //   // navigate('/details'); // Navigate after successful form submission
      // }
    } catch (err) {
      console.log(err)
    }
  }

  const sbtHnd = async (e) => {
    e.preventDefault();
    setIsSubmit(true)

    // Form data to send
    const formData = {
      name: name,
      mobile: mobile,
      email: email,
      city: city,
      link: fullLink
    };

    //https://webhooks.integrately.com/a/webhooks/758b9471ed0142309c62b99cd07b7622
    //https://webhooks.integrately.com/a/webhooks/4cda4f85c81d431bb6b29aa6ed5c6b9d
    try {
      // Send data to webhook
      const response = await axios.post(
        'https://webhooks.integrately.com/a/webhooks/4cda4f85c81d431bb6b29aa6ed5c6b9d',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        setIsSubmit(false)
        alert('Form submitted successfully!');
        setName('');
        setMobile('');
        setEmail('');
        setCity('');
        setIsSubmit(false);
        navigate('/details'); // Navigate after successful form submission
      }
    } catch (error) {
      setIsSubmit(false)
      // alert('Error sending form data');
      toast.error('Error submitting form');
    }
  };

  return (
    <div>
      <Button
        onClick={showLoading}
        className='w-10/12 md:w-3/12 h-16 rounded-xl text-3xl mx-auto text-black font-medium block bg-gradient-to-l from-gold2 to-gold1 px-8 mt-4 border-2 border-white'
      >
        Apply Now
      </Button>

      <Modal
        title={<p className='text-center text-md mr-2  md:text-xl'>Take the First Step - Schedule Your Consultation</p>}
        footer={<p></p>}
        loading={loading}
        open={open}
        onCancel={() => setOpen(false)}
      >
        {/* <p className=''></p> */}

        {/* Use ref on the form */}
        <form ref={formRef} onSubmit={sbtHnd} autoComplete="off" className='flex flex-col space-y-4'>
          <input
            name='user_name'
            type='text'
            className='rounded-md h-12 border border-solid border-gold1 px-2'
            placeholder='Name'
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            name='user_mobile'
            // type='number'
            type='tel'
            className='rounded-md h-12 border border-solid border-gold1 px-2'
            placeholder='Mobile'
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
          <input
            name='user_email'
            type='email'
            className='rounded-md h-12 border border-solid border-gold1 px-2'
            placeholder='Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            name='user_city'
            type='text'
            className='rounded-md h-12 border border-solid border-gold1 px-2'
            placeholder='City'
            value={city}
            onChange={(e) => setCity(e.target.value)}
            required
          />

          <button disabled={isSubmit} type='submit' className='rounded-md font-medium bg-gradient-to-l from-gold2 to-gold1 px-4 py-3'>
            {isSubmit ? "Wait..." : "Submit"}
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default Modall;
